module.exports = __webpack_public_path__ + "static/baycrest-logo-318fab17cb3cef1186132399e1ec1745.png";